<!--
@name 硕士教育-资产管理与金融硕士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          资产管理与金融硕士专业致力于为学生提供全面、深入的金融知识教育，旨在培
          养具备优秀金融知识、职业素养和国际视野的高层次金融人才。学院拥有丰富的教学
          资源和优秀的师资队伍，为学生提供优质的学习环境和实践机会。
        </div>
        <div class="selector-indent">
          该专业课程涵盖了宏观经济学、微观经济学、商法、组织行为学等相关课程。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">卓越资质</p>
          <p>
            AACSB认证的全球顶尖精英商校，中国教育部涉外信息监管网可查。
          </p>
          <p class="advantage-title">正规保障</p>
          <p>免考试，面试审核制入学，校本部直招，法国校本部学籍注册，中国国内在职研读。</p>
          <p class="advantage-title">课程完善</p>
          <p>
            在学习过程中，资产管理与金融硕士学员将接受系统的理论和实践培训，课程设置
            包括宏观经济学、微观经济学、商法、组织行为学等相关课程。</p>
          <p class="advantage-title">实战体系</p>
          <p>
            立足本土实用导向的课程设计，“课堂讲授+案例分析+共创工作坊+沉浸式研学”
            多种形式相结合，提升理论应用、分析和解决实际管理问题的能力。
          </p>
          <p class="advantage-title">雄厚师资</p>
          <p>汇聚国内外重点高校知名专家教授、行业领袖精英等联袂传授，兼具卓越的学术教
            研能力与丰富实践经验，多元视角、智慧碰撞，拓展广阔视野与人生格局。</p>
          <p class="advantage-title">广阔平台</p>
          <p> 庞大的校友网络、专家智库、政府与金融机构链接等，搭建高端商务交流、资源整
            合的优质平台。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <!--    <div class="cont-item">-->
      <!--      <div class="title-image">培养方式</div>-->
      <!--      <div>-->
      <!--        法国布雷斯特高等商学院健康管理硕士学位课程采用线上教学加线下实践、自主-->
      <!--        学习和毕业论文相结合的方式进行为期一年半的学习，毕业季时组织学生集体去-->
      <!--        法国参加研修及毕业典礼。-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    &lt;!&ndash; 培养方式 &ndash;&gt;-->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程介绍</div>
        <p>资产管理与金融硕士学制18个月，课程共15门，12门必修课，2门选修课，1门语言课，修满60学分进入论文答辩阶段。</p>
        <img src="@/assets/images/personRain/mafm-course.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="@/assets/images/personRain/mba-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科或同等学历</p>
        <p>专科毕业，拥有三年及以上管理经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">资产管理与金融硕士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 相关资料下载 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'EduFinance',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/9E/wKgCEmfD3BWAAGiLAIcLUwIxyKU240.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduFinance.vue